export default function divider({ variables }) {
    return {
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: variables.border_subtle,
                },
            },
        },
    };
}
//# sourceMappingURL=divider.js.map